import React from 'react';
import PropTypes from 'prop-types';
import { FilterSection } from './filter_section';
import { FilterSelect } from './filters/filter_select';
import TranslationContainer from '../../../translation/translation_container';
import { Filters } from '../../../../constants/filter/filters';
import { FilterLabelTranslationKeys } from '../../../../constants/filter/filter_label_translation_keys';

function Ev(props) {
    const opened = props.opened || !!props.evValue;
    const evTranslationKey = FilterLabelTranslationKeys[Filters.EV];
    return (
        <FilterSection
            opened={opened}
            resettable={props.resettable}
            onActionClick={props.onActionClick}
            headline="catalog-filters-section-headline-ev"
            containerModifier="ev"
        >
            <TranslationContainer
                targetProperties={{
                    tooltipContent: { translationKey: 'catalog-filter-ev-tooltip-text' },
                }}
            >
                <FilterSelect
                    name={Filters.EV}
                    value={props.evValue}
                    options={props.evOptions}
                    labelTranslationKey={evTranslationKey}
                    provideAllTranslationKey="catalog-filters-ev-select-label-all"
                    onChange={props.onEvChange}
                    onToolTipHover={() => props.onToolTipHover('Ev')}
                    provideAllOption={true}
                    tooltipContent="There should be some text here"
                    highlight={!props.evValue}
                    unavailableOptions = {[]}
                />
            </TranslationContainer>
        </FilterSection>
    );
}

Ev.propTypes = {
    evValue: PropTypes.string.isRequired,
    evOptions: PropTypes.array.isRequired,
    opened: PropTypes.bool.isRequired,
    resettable: PropTypes.bool.isRequired,
    onActionClick: PropTypes.func.isRequired,
    onEvChange: PropTypes.func.isRequired,
    onToolTipHover: PropTypes.func.isRequired,
};

export { Ev };
